// Options for data views (four panes in the bottom left section of the dashboard)
const dvOptions = {
    battery_pack: "battery_pack",
    cell_groups: "cell_groups",
    ppc_mppt: "ppc_mppt",
    communication: "communication",
    system_power: "system_power",
    motor_motion: "motor_motion",
    temperature: "temperature",
    select: ""
};

export default dvOptions;
